import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../../footer/footer";
import profilePlaceHolder from "../../../../static/img/profilePlaceHolder.svg";
import backIcon from "../../../../static/img/back.svg";
import searchIcon from "../../../../static/img/searchIconGrey.svg";
import { handleSearch } from "../../../../utils/search";
import PerfilEntrenador from "../perfilEntrenador/perfilEntrenador";
import { getTrainerList } from "../../../../services/deportistaApi";
import { getUserId } from "../../../../services/utilsApi";
import "./styles.css";

const BuscarEntrenadores = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [trainers, setTrainers] = useState([]);
  const [filteredTrainers, setFilteredTrainers] = useState([]);
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [loggedUserId, setLoggedUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const trainerId = searchParams.get("id");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: userIdResponse } = await getUserId();
        setLoggedUserId(userIdResponse.user_id);

        const response = await getTrainerList();
        if (response.data.success) {
          const trainersData = response.data.entrenadores.map((trainer) => ({
            id: trainer.id,
            nombre: `${trainer.nombre} ${trainer.apellido}`,
            foto: trainer.foto || "",
            deportistas_asignados: trainer.deportistas_asignados || [],
          }));
          setTrainers(trainersData);
          setFilteredTrainers(trainersData);
        }
      } catch (error) {
        console.error("Error al obtener entrenadores:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (trainerId && trainers.length > 0) {
      const trainer = trainers.find((t) => t.id === parseInt(trainerId));
      if (trainer) setSelectedTrainer(trainer);
    }
  }, [trainerId, trainers]);

  const onSearchChange = (e) => {
    handleSearch(e, trainers, setSearchTerm, setFilteredTrainers);
  };

  const handleTrainerClick = (trainer) => {
    setSelectedTrainer(trainer);
  };

  const closeTrainerModal = () => {
    setSelectedTrainer(null);
  };

  const handleBack = () => {
    setSelectedTrainer(null);
    navigate("/dashboard");
  };

  return (
    <div className="buscar-entrenadores-container">
      <div className="buscar-entrenadores-header">
        <button className="back-button-entrenadores" onClick={handleBack}>
          <img src={backIcon} alt="Volver" />
        </button>
        <div className="header-title">Entrenadores</div>
      </div>

      <div className="search-bar-entrenadores">
        <img src={searchIcon} alt="Buscar" className="search-icon" />
        <input
          type="text"
          placeholder="Buscar"
          className="search-input"
          value={searchTerm}
          onChange={onSearchChange}
        />
      </div>

      {loading ? (
        <p className="loading-text">Cargando entrenadores...</p>
      ) : (
        <div className="entrenadores-list" data-testid="entrenadores-list">
          {filteredTrainers.map((trainer) => (
            <div
              key={trainer.id}
              className="entrenador-card"
              onClick={() => handleTrainerClick(trainer)}
            >
              <div className={`perfil-avatar-placeholder ${!trainer.foto || trainer.foto.includes("default") ? "without-photo" : "with-photo"}`}>
                <img
                  className={`perfil-avatar-holder ${!trainer.foto || trainer.foto.includes("default") ? "without-photo" : "with-photo"}`}
                  alt={`${trainer.nombre}`}
                  src={!trainer.foto || trainer.foto.includes("default") ? profilePlaceHolder : trainer.foto}
                />
              </div>
              <span className="entrenador-name">{trainer.nombre}</span>
            </div>
          ))}
        </div>
      )}

      <Footer activeScreen="entrenadores" />

      {selectedTrainer && (
        <PerfilEntrenador
          trainerId={selectedTrainer.id}
          deportistasAsignados={selectedTrainer.deportistas_asignados}
          loggedUserId={loggedUserId}
          onClose={closeTrainerModal}
        />
      )}
    </div>
  );
};

export default BuscarEntrenadores;
